import { IUserProfilePicture } from '../interfaces/user-profile-picture.interface';

export class UserProfilePicture {
    url: string | null;
    smallUrl: string | null;
    thumbUrl: string | null;
    largeUrl: string | null;

    constructor(query: IUserProfilePicture) {
        this.url = query.url;
        this.smallUrl = query.small_url;
        this.thumbUrl = query.thumb_url;
        this.largeUrl = query.large_url;
    }
}
